import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "All set to lift-off", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Your event is ready to publish", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Silhouette of mountains",
  src: "https://ionicframework.com/docs/img/demos/card-media.png"
}, null, -1)
const _hoisted_5 = { class: "container" }

import { arrowForward } from "ionicons/icons";
import {
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonCardContent,
  IonIcon,
  IonPage,
  IonContent,
  useIonRouter,
} from "@ionic/vue";
import { useContextStore } from "@/stores/context";


export default /*#__PURE__*/_defineComponent({
  __name: 'Success',
  setup(__props) {

const router = useIonRouter();
const contextStore = useContextStore();

const goToEvent = () => {
  router.push(`/event/${contextStore.event.id}/home`);
};

return (_ctx: any,_cache: any) => {
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("section", null, [
              _hoisted_2,
              _hoisted_3,
              _createVNode(_unref(IonCard), {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (goToEvent()))
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createVNode(_unref(IonCardHeader), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCardTitle), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(contextStore).event.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonCardSubtitle), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(contextStore).event.start_date) + " - " + _toDisplayString(_unref(contextStore).event.end_date), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonCardContent), null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Here's a small text description for the card content. Nothing more, nothing less. ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("section", null, [
              _createVNode(_unref(IonButton), {
                expand: "block",
                color: "dark",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (goToEvent()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "start",
                    icon: _unref(arrowForward)
                  }, null, 8, ["icon"]),
                  _createTextVNode(" Go to event ")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})